import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler, HttpInterceptor, HttpParams, HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import 'rxjs/add/operator/do';

/**
 * Interceptor per gestire l'autenticazione tramite token.
 * Quanto intercetta una chiamata imposta l'opzione withCredentials per inviare il cookie insieme alla richiesta.
 *
 * In caso di errore http si viene direzionati su blank.
 * Solo la pagina /blank è esente da questo meccanismo per evitare loop.
 */
@Injectable()
export class TokenAuthService implements HttpInterceptor {

  constructor(private router: Router) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const newParams = { withCredentials: true };

    let req = request.clone(newParams);

    if (document.location.href.indexOf('/blank') > -1) {
      return Observable.empty();
    }

    return next.handle(req).do((event: HttpEvent<any>) => {
    }, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        console.error(err);
        this.router.navigate(['/blank']);
        return next.handle(req);
      }
    });

    /*if(document.location.href.indexOf('/blank') > -1) {

    } else {
      return next.handle(req);
    }*/
  }

}





// WEBPACK FOOTER //
// ./src/app/auth/token-auth.service.ts